var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-box"},[_c('span',{staticClass:"badge badge-danger m-r-5"},[_vm._v("NEW")]),_c('a',{attrs:{"href":"#"}},[_vm._v("?")])])}]

export { render, staticRenderFns }